export default "<div id=\"popup\">\n    <div class=\"popup-container\">\n\n    </div>\n</div>"